import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const WHATSAPP_FALLBACK = '5521985362281';

export const WhatsAppFloat = () => {
  const location = useLocation();
  const [numero, setNumero] = useState(WHATSAPP_FALLBACK);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/configuracoes`)
      .then(res => res.json())
      .then(data => {
        if (data && data.whatsapp) {
          const n = data.whatsapp.replace(/[\s()\-+]/g, '');
          if (n.length >= 10) setNumero(n);
        }
      })
      .catch(() => {});
  }, []);

  const path = location.pathname;
  if (path.startsWith('/imovel/') || path === '/grupo-corretores' || path.startsWith('/admin')) {
    return null;
  }

  const msg = encodeURIComponent('Olá, gostaria de mais informações.');
  const url = `https://wa.me/${numero}?text=${msg}`;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" aria-label="Falar no WhatsApp" data-testid="whatsapp-float" className="fixed bottom-5 right-5 z-50 bg-whatsapp hover:bg-whatsapp-hover text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition hover:scale-105">
      <FaWhatsapp size={30} />
    </a>
  );
};
